// extracted by mini-css-extract-plugin
export default {"wrapper":"WorkspaceBusinessPlansMobile_wrapper__RFihJ"};